import React, { ReactNode, memo } from 'react';

import styles from './BorrowerFiel.module.scss';

interface ABorrowerFieldProps {
  children: ReactNode;
  fieldTitle: string;
}

const BorrowerField = memo(({ children, fieldTitle }: ABorrowerFieldProps) => {
  return (
    <div className={styles.borrowerField}>
      <p className={styles.borrowerFieldTitle}>{fieldTitle}</p>
      <p className={styles.borrowerFieldText}>{children}</p>
    </div>
  );
});

export default BorrowerField;
